import { Navigate, Route, Routes } from 'react-router-dom';
import SetPassword from '../components/auth/SetPassword';
import ResetPassword from '../components/auth/ResetPassword';
import Login from '../components/auth/Login';
import React from 'react';
import LinkExpired from '../components/auth/LinkExpired';

const AuthRouter = () => (
  <Routes>
    <Route index element={<Navigate to={'login'}/>}/>
    <Route path="set-password" element={<SetPassword/>}/>
    <Route path="reset-password" element={<ResetPassword/>}/>
    <Route path="login" element={<Login/>}/>
    <Route path="link-expired" element={<LinkExpired/>}/>
    <Route path="*" element={<Navigate to={'login'}/>}/>
  </Routes>
);

export default AuthRouter;